import { generateSourcesForPicture, Picture } from '@farmersdog/corgi-x';
import styles from './ApopLogo.module.css';

import ApopLogoPng from '../apop-logo.png';
import ApopLogoWebp from '../apop-logo.webp';

const ApopLogoSources = {
  webp: ApopLogoWebp,
  png: ApopLogoPng,
};

/**
 * Lazy loaded APOP logo.
 * Intended for use below the fold.
 **/
export const ApopLogo = () => {
  const wsavaLogoAssets = generateSourcesForPicture({
    desktopSources: ApopLogoSources,
    mobileSources: ApopLogoSources,
  });

  return (
    <Picture
      loading="lazy"
      alt="Association for Pet Obesity Prevention Logo"
      sources={wsavaLogoAssets}
      className={styles.root}
    />
  );
};
